import React from 'react';
import { Typography } from '@mui/material';
import { trayOnboardingStatus } from 'api/Responses/SatoResponses';
import { DraftTrayResponse } from 'api/Responses/TrayResponses';
import AsyncImage from 'components/AsyncImage/AsyncImage';
import { StatusTile } from 'components/StatusTile/StatusTile';
import { useLanguage } from 'context/AppContext';
import { StorageType } from 'utils/helpers/image.helpers';
import * as styles from './TrayCard.styles';

interface TrayCardProps {
  setCode: string;
  tray: DraftTrayResponse;
}

const TrayCard: React.FC<TrayCardProps> = ({ setCode, tray }) => {
  const [language] = useLanguage();

  return (
    <styles.Card href={`/sato/${setCode}/${tray.tray_id}`}>
      <styles.ImageContainer>
        <AsyncImage
          imgWidth={'100%'}
          imgHeight={'100%'}
          src={tray.tray_image}
          alt={tray.tray_description}
          storageType={StorageType.FIREBASE}
        />
      </styles.ImageContainer>

      <styles.InfoContainer>
        <Typography variant="h6" component="h4">
          {tray.tray_ref} - {tray.tray_description}
        </Typography>
        <StatusTile status={trayOnboardingStatus[tray.status]}>{language.Sato.status[tray.status]}</StatusTile>
      </styles.InfoContainer>
    </styles.Card>
  );
};

export default TrayCard;
